module.exports = __webpack_public_path__ + "img/layers-grey.1251c231.svg";